import styled, { ThemeProps } from 'styled-components'

interface DropZoneProps extends ThemeProps<any> {
    isDragging: boolean
    hasError: boolean
    disabled: boolean
}

export const DropZoneStyled = styled.div.attrs((props: DropZoneProps) => ({}))<DropZoneProps>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 16px 12px;
    width: 100%;
    border: dashed 2px
        ${(props) =>
            props.hasError ? props.theme.colors.error : props.isDragging ? props.theme.colors.accentColor : props.theme.colors.dark[1]};
    border-radius: 6px;
    background-color: ${(props) => (props.isDragging ? props.theme.colors.accentColorMuted : 'transparent')};
    color: ${(props) => props.theme.table.columnColor};
    font-size: ${(props) => props.theme.table.columnFontSize};
    text-align: center;
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
    opacity: ${(props) => (props.disabled ? 0.5 : 1)};
    transition: border-color 0.15s ease-in-out, background-color 0.15s ease-in-out;

    &:hover {
        border-color: ${(props) => (props.disabled ? undefined : props.theme.colors.accentColor)};
    }

    i {
        font-size: 20px;
        color: ${(props) => props.theme.colors.accentColor};
    }
`

export const DropZoneHintStyled = styled.div`
    font-size: 12px;
    color: ${(props) => props.theme.table.columnColor};
    opacity: 0.7;
`

export const BrowseLinkStyled = styled.span`
    color: ${(props) => props.theme.colors.accentColor};
    text-decoration: underline;
`

export const SelectedFileStyled = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-top: 8px;
    font-size: 14px;
    color: ${(props) => props.theme.table.columnColor};

    .file-name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 220px;
    }

    .file-size {
        opacity: 0.7;
        font-size: 12px;
        white-space: nowrap;
    }

    .remove-file {
        cursor: pointer;
        color: ${(props) => props.theme.colors.error};
    }
`

export const HiddenFileInputStyled = styled.input`
    display: none;
`
